import _extends from 'babel-runtime/helpers/extends';

/**
 * 评论列表
 */
import ReplyComment from '@/components/ReplyComment';
import { setCommentAPI, deleteCommentAPI } from '@/api/oa/common';
import { mapGetters } from 'vuex';
import xss from 'xss';

export default {
  name: 'CommentList',
  components: {
    ReplyComment: ReplyComment
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    // 1是任务 2是日志
    type: [String, Number]
  },
  data: function data() {
    return {
      replyIndex: null,
      commentLoading: false
    };
  },

  computed: _extends({}, mapGetters(['userInfo'])),
  methods: {
    /**
     * 显示回复框
     * @param index
     * @param childIndex
     */
    handleToReply: function handleToReply(index) {
      var childIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var str = '' + index + (childIndex !== null ? '-' + childIndex : '');
      this.$emit('close-other-reply');
      if (str === this.replyIndex) return;
      this.replyIndex = str;
    },
    closeReply: function closeReply() {
      this.replyIndex = null;
    },

    /**
     * 子评论排序
     */
    // sortChildComment(childList) {
    //   let arr = [].concat(childList || [])
    //   arr = arr.sort((a, b) => {
    //     return new Date(b.create_time) - new Date(a.create_time)
    //   }) || []
    //   return arr
    // },
    /**
     * 回复
     * @param data
     */
    handleReply: function handleReply(data) {
      var _this = this;

      var params = {
        type: this.type,
        content: xss(data),
        type_id: this.id
      };
      var c_comment = null;
      var arr = this.replyIndex.split('-');
      var f_comment = this.list[arr[0]];
      if (arr[1]) {
        c_comment = f_comment.childCommentList[arr[1]];
      }
      if (f_comment) {
        params.main_id = f_comment.comment_id;
        params.comment_id = f_comment.childCommentList.comment_id || f_comment.comment_id;
      }
      if (c_comment) {
        params.comment_id = c_comment.comment_id;
      }
      this.commentLoading = true;
      setCommentAPI(params).then(function (res) {
        res.data.userInfo = {
          user_id: _this.userInfo.id,
          realname: _this.userInfo.realname,
          img: _this.userInfo.img
        };
        if (c_comment) {
          res.data.replyuserInfo = c_comment.userInfo;
        } else {
          res.data.replyuserInfo = f_comment.userInfo;
        }
        _this.list[arr[0]].childCommentList.push(res.data);
        _this.replyIndex = null;
        _this.commentLoading = false;
      }).catch(function () {
        _this.commentLoading = false;
      });
    },

    /**
     * 删除回复
     */
    handleToDelete: function handleToDelete(data, index) {
      var _this2 = this;

      var childIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteCommentAPI({
          comment_id: data.comment_id,
          task_id: _this2.id
        }).then(function (res) {
          _this2.$message({
            type: 'success',
            message: '删除成功!'
          });

          if (childIndex >= 0) {
            _this2.list[index].childCommentList.splice(childIndex, 1);
          } else {
            _this2.$emit('delete', index);
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};